'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDefaultCategoriesByPlatform = exports.filterGamesPlatforms = exports.supportsIframe = void 0;
var game_1 = require("@gig/magic-sdk/dist/adapter/games/game");
var vendorsSupportingIframe = [
    game_1.GameVendor.PLAY_N_GO,
    game_1.GameVendor.YGGDRASIL,
    game_1.GameVendor.RED_TIGER,
    game_1.GameVendor.EDICT,
    game_1.GameVendor.PRAGMATIC_PLAY,
    game_1.GameVendor.EVOLUTION,
    game_1.GameVendor.MICROGAMING,
    game_1.GameVendor.IGT,
    game_1.GameVendor.GREEN_TUBE,
    game_1.GameVendor.NO_LIMIT_CITY,
    game_1.GameVendor.THUNDERKICK,
    game_1.GameVendor.SLINGO,
    game_1.GameVendor.GIG_GAMES,
    game_1.GameVendor.ORYX_GAMING,
    game_1.GameVendor.BLUEPRINT,
    game_1.GameVendor.QUICKSPIN,
];
/**
 * Checks whether game supports iframe
 */
function supportsIframe(game, iframeGameProviders) {
    var providers = iframeGameProviders
        ? iframeGameProviders
        : vendorsSupportingIframe;
    return providers.includes(game.vendor);
}
exports.supportsIframe = supportsIframe;
/**
 * Filters the games list based on available platform.
 * @param games Games list
 * @param isMobile Whether playing on a mobile device or not
 */
function filterGamesPlatforms(games, isMobile) {
    return games.filter(function (game) {
        if (!game.platform) {
            return true;
        }
        return (game.platform.mobile === isMobile ||
            game.platform.desktop === !isMobile);
    });
}
exports.filterGamesPlatforms = filterGamesPlatforms;
/**
 * Filter default categories (defined in config.json) by platform.
 * It relies on the fact that mobile default categories are suffixed by `-mobile`
 *
 * @param defaultCategories the default category list
 * @param isMobile if platform is mobile
 * @returns filtered list of categories
 */
function filterDefaultCategoriesByPlatform(defaultCategories, isMobile) {
    return defaultCategories.filter(function (category) {
        return isMobile
            ? category.toLowerCase().endsWith('-mobile')
            : !category.toLowerCase().endsWith('-mobile');
    });
}
exports.filterDefaultCategoriesByPlatform = filterDefaultCategoriesByPlatform;
